import { render } from "./OTP2.vue?vue&type=template&id=377ef592"
import script from "./OTP2.vue?vue&type=script&lang=js"
export * from "./OTP2.vue?vue&type=script&lang=js"

import "./OTP2.vue?vue&type=style&index=0&id=377ef592&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__